import {Button, useColorModeValue} from '@chakra-ui/react';
import {TablerArrowLeft} from '../../icons';

// The single back affordance for drilled-in detail views (encounter detail,
// phone / telephone encounter, unlinked session, patient history). A prominent
// upper-left "← {label}" ghost button — the one obvious way out — so every
// detail surface dismisses the same way instead of a mix of in-card chevrons
// and corner X buttons.
const DetailBackButton = ({
  label = 'Back',
  onClick,
  testId,
  ...rest
}: {
  label?: string;
  onClick?: () => void;
  testId?: string;
} & Record<string, any>) => {
  const color = useColorModeValue('gray.800', 'gray.100');
  const hoverBg = useColorModeValue('gray.100', 'whiteAlpha.200');
  return (
    <Button
      type="button"
      variant="ghost"
      size="sm"
      alignSelf="flex-start"
      leftIcon={<TablerArrowLeft size={18} aria-hidden="true" />}
      color={color}
      fontWeight="semibold"
      ml={-2}
      onClick={onClick}
      data-testid={testId}
      aria-label={label}
      _hover={{bg: hoverBg}}
      {...rest}
    >
      {label}
    </Button>
  );
};

export default DetailBackButton;
